import {apiClient} from "../../../../lib/api-client";
import {ApiResult} from "../../../../types/ApiResult";
import {KindOfOrder} from "../../../../types/enums";
import {OrderNote} from "../types/OrderNote";


export async function apiEmailOrderNote(orderID: number, kindOfOrder: KindOfOrder, note: OrderNote): Promise<ApiResult> {
    try {
        return await apiClient.post("note/email", {
            orderID: orderID,
            kindOfOrder: kindOfOrder,
            noteText: note.noteText,
            emailSubject: note.emailSubject,
            toEmailAddress: note.toEmailAddress,
            urgent: note.urgent,
            noteType: note.noteType
        });
    }
    catch (error) {
        return {
            isSuccess: false,
            errorMessage: "Error when emailing the note: " + error
        };
    }
}
